import { toast } from 'react-toastify';
import {
  SET_FUNNEL_STATUS,
  SET_FUNNEL_TYPE,
  SET_LEADS,
  SET_SEARCH_LEADS,
  SET_RESPONSIBLE,
  SET_WORK_TECH,
  SET_WORK_TYPE,
  SET_LEAD_REDMINE_TO_EDIT,
  SET_LEAD_TO_EDIT,
  SET_ACCOUNTS_OWNERS,
  SET_PROPOSAL_TYPES,
  SET_OFFSET,
  SET_POPUP_REDMINE,
  SET_POPUP,
  SET_TYPE_OF_POPUP_DATA,
  SET_TYPE_OF_REDMINE_DATA,
  SET_NEW_LEAD_ID,
  SET_UPDATE_NEW_LIST_LEADS_REDMINE_POPUP,
  SET_ISCHECKEXISTS,
} from '../actionTypes';
import api from '../../api';
import { showToastError } from '../../components/utils';

export function getLeads(filters) {
  return (dispatch) => api.getByQuery('lead', `?${filters}`).then((res) => dispatch({
    type: SET_LEADS,
    payload: res.data,
  }));
}
export const addSearchLeads = (array) =>
// console.log(array);
  ({
    type: SET_SEARCH_LEADS,
    payload: { array },
  });
// console.log('action is ended');

export function getFunnelType() {
  return (dispatch) => api.get('funnel_type').then((res) => dispatch({
    type: SET_FUNNEL_TYPE,
    payload: res.data,
  }));
}
export function getFunnelStatus() {
  return (dispatch) => api.get('funnel_status').then((res) => dispatch({
    type: SET_FUNNEL_STATUS,
    payload: res.data,
  }));
}
export function getWorkType() {
  return (dispatch) => api.get('work_type').then((res) => dispatch({
    type: SET_WORK_TYPE,
    payload: res.data,
  }));
}
export function getWorkTech() {
  return (dispatch) => api.get('work_tech').then((res) => dispatch({
    type: SET_WORK_TECH,
    payload: res.data,
  }));
}
export function getResponsible() {
  return (dispatch) => api.get('responsible').then((res) => dispatch({
    type: SET_RESPONSIBLE,
    payload: res.data,
  }));
}
export function postLead(data, redirector) {
  return () => api
    .post('lead', data)
    .then((res) => {
      toast.success('You successfully create new lead', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
      if (res.data && res.data.id) {
        redirector(`/lead/${res.data.id}`);
      } else {
        redirector('/lead-list');
      }
    })
    .catch((err) => {
      showToastError(err);
    });
}

export function postNewLeadUpWork(data) {
  return (dispatch) => api
    .post('lead', data)
    .then((res) => {
      toast.success('You successfully create new lead', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2500,
      });
      const result = dispatch({
        type: SET_LEAD_TO_EDIT,
        payload: res.data,
      });
      return result;
    })
    .catch((err) => {
      showToastError(err);
    });
}

export function getLeadByID(id) {
  return (dispatch) => api.getByQuery('lead', `/${id}`).then((res) => {
    const result = dispatch({
      type: SET_LEAD_TO_EDIT,
      payload: res.data,
    });
    return result;
  });
}

export function setSelectedLeadRedmine(data) {
  return (dispatch) => dispatch({
    type: SET_LEAD_REDMINE_TO_EDIT,
    payload: data,
  });
}

export function setSelectedLead(data) {
  return (dispatch) => dispatch({
    type: SET_LEAD_TO_EDIT,
    payload: data,
  });
}
export function setNewDataLead(
  id,
  data,
  redirector,
  isRedirectionArable,
  stay,
) {
  return () => api.put('lead', id, data).then(() => {
    if (stay) {
      return;
    }
    if (!isRedirectionArable) {
      redirector(window.history.back());
    } else {
      window.location.reload(false);
    }
  });
}
export function setNewLeadDate(id, data) {
  return () => api.put('lead', id, data);
}
export function checkByJobPost(data) {
  return () => api.post('checkByJob', data);
}
export function gotAnsweredResponsible(id, responsibleState, redirector) {
  // console.log(id);
  return () => api.post('gotanswer', responsibleState, id).then(() => {
    redirector(window.history.back());
  });
}
export function gotFineDoneResponsible(id, responsibleState, redirector) {
  return () => api.post('finedone', responsibleState, id).then(() => {
    redirector(window.history.back());
  });
}
export function gotRawDoneResponsible(id, data, redirector) {
  return () => api.post('rawdone', data, id).then(() => {
    redirector(window.history.back());
  });
}
export function dealLeadPost(id, data) {
  return () => api.post('deal', data, id);
}
export function notQualifiedLeadPost(id, data) {
  return () => api.post('notqualified', data, id);
}
export function RedminePost(id, data) {
  return () => api.post('deal', data, id);
}
export function addNewComment(id, data, redirector) {
  return () => api.post('comment', data, id).then(() => {
    redirector(window.history.back());
  });
}
export function getAccountOwnersList() {
  return (dispatch) => api.get('upworkAccount').then((res) => dispatch({
    type: SET_ACCOUNTS_OWNERS,
    payload: res.data,
  }));
}
export function getProposalType() {
  return (dispatch) => api.get('proposalTypes').then((res) => dispatch({
    type: SET_PROPOSAL_TYPES,
    payload: res.data,
  }));
}
export function setUpWorkData(data) {
  return () => api.put('upworkAdditional', '', data);
}
export function setFirstMessage(data) {
  return () => api.put('leadFirstMessage', '', data);
}

export function setTopOffset(value) {
  return (dispatch) => {
    dispatch({
      type: SET_OFFSET,
      payload: value,
    });
  };
}

export function setPopupRedmineActivity() {
  return (dispatch) => {
    dispatch({
      type: SET_POPUP_REDMINE,
    });
  };
}
export function updatedArrayFromRedminePopup(type) {
  return (dispatch) => {
    dispatch({
      type: SET_UPDATE_NEW_LIST_LEADS_REDMINE_POPUP,
      payload: type,
    });
  };
}

export function setPopupActivity() {
  return (dispatch) => {
    dispatch({
      type: SET_POPUP,
    });
  };
}

export function setRedmineLink(type) {
  return (dispatch) => {
    dispatch({
      type: SET_TYPE_OF_REDMINE_DATA,
      payload: type,
    });
  };
}

export function setPopupType(type) {
  return (dispatch) => {
    dispatch({
      type: SET_TYPE_OF_POPUP_DATA,
      payload: type,
    });
  };
}
